import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomSwitch from '../forms/theme-elements/CustomSwitch';
import CusTooltip from './CusTooltip';
import CustomSwitch2 from '../forms/theme-elements/CustomSwitch2';
import CustomSmallSwitch from '../forms/theme-elements/CustomSmallSwitch';

export default function CusSwitch({
  label,
  reverse,
  checked,
  disabled,
  readOnly,
  onChange,
  isColumn,
  sx,
  isVerySmall,
  fontSize,
  fontWeight,
  withoutPadding,
  labelWidth,
  tooltipText
}) {
  const { t } = useTranslation();

  const switchProps = {
    checked: checked,
    onChange: onChange,
    disabled: disabled,
    readOnly: readOnly
  };

  return (
    <Stack
      display={'flex'}
      direction={isColumn ? 'column' : reverse ? 'row-reverse' : 'row'}
      gap={isColumn ? 0 : 0.5}
      alignItems={isColumn ? 'start' : 'center'}
      sx={sx}>
      <Stack direction={'row'} gap={0.5} alignItems={'center'}>
        <Typography
          fontSize={fontSize}
          fontWeight={fontWeight}
          color={disabled ? 'textDisabled' : 'textPrimary'}
          labelWidth={labelWidth}
          sx={{ cursor: readOnly ? 'default' : 'pointer' }}
          onClick={() => onChange()}>
          {t(label)}
        </Typography>
        <CusTooltip text={tooltipText} />
      </Stack>
      {withoutPadding ? (
        <CustomSwitch2 {...switchProps} />
      ) : isVerySmall ? (
        <CustomSmallSwitch {...switchProps} />
      ) : (
        <CustomSwitch {...switchProps} />
      )}
    </Stack>
  );
}
